<script>
import diets from '@/assets/diets-options'

const slug = require('slug')
const sw = require('stopword')

export default {
  name: 'ChefCard',
  props: {
    chef: { type: Object, required: true }
  },
  methods: {
    tags(product) {
      if (!product) return
      const { map } = this.lodash

      const tags = map(product.tags, tag => {
        const diet = diets.find(
          x => x.value === tag && ['VEGAN', 'VEGETARIAN'].indexOf(x.value) > -1
        )
        if (diet) return { text: diet.tag, color: 'light-green' }
        return null
      }).filter(x => x)

      if (product.left && product.left <= 5) {
        tags.unshift({
          text: `${product.left} left`,
          color: 'accent'
        })
      }

      return tags
    }
  }
}
</script>

<template>
  <v-card
    flat
    class="chef-card"
    :to="{
      name: 'ChefView',
      params: { slug: chef.slug, preloaded: { chef } }
    }"
    :ripple="false"
  >
    <!-- Product photo -->
    <v-img
      v-for="product in chef.sellerProducts.slice(0, 1)"
      :key="product.id"
      color="grey lighten-3 ma-0"
      size="100%"
      class="product-photo"
      :src="product.photo"
      :lazy-src="product.photo"
      gradient="to top, rgba(0,0,0,.75), rgba(0,0,0,0) 75%"
    >
      <!-- Halal-friendly -->
      <span>
        <v-chip
          v-if="chef.agreements && chef.agreements.halal"
          color="white"
          text-color="black"
          class="px-1 halal-friendly"
          x-small
        >
          Halal-friendly
        </v-chip>
      </span>
    </v-img>

    <v-list-item-content class="chef-description">
      <div class="pb-3">
        <v-img :src="chef.avatar" :lazy-src="chef.avatar" class="chef-avatar" />
      </div>
      <div class="display-1 font-weight-bold mb-2 white--text chef-name">
        {{ chef.firstName }}
      </div>
      <div
        v-if="chef.story"
        class="headline font-weight-bold mb-2 white--text chef-story"
      >
        {{ chef.story }}
      </div>
    </v-list-item-content>
  </v-card>
</template>

<style scoped lang="sass">
.chef-card
  width: 100%
  font-size: 14px
  overflow: hidden

.product-photo
  border-radius: 4px

.chef-description
  position: absolute
  bottom: 0
  padding: 20px
  width: 100%
  .chef-avatar
    width: 60px
    height: 60px
    border-radius: 50%
    border: 2px solid rgba(255,255,255,0.75)
  .chef-name
  .chef-story
    font-size: 1.4rem !important

.halal-friendly
  position: absolute
  top: 20px
  right: 15px

.actions .v-btn
  &:before
    background-color: white !important
</style>
